const SITE = 'https://forum-industry.ru';

const FALLBACK_DESCRIPTION =
  'Форум «Индустрия ИИ» — реальные кейсы внедрения искусственного интеллекта для собственников и управленцев МСП. 18 июня 2026, Mirotel, Новосибирск.';

export const seoMeta = {
  '/': {
    title: 'Индустрия ИИ — форум, 18 июня 2026, Новосибирск',
    description: FALLBACK_DESCRIPTION
  },
  '/tariff': {
    title: 'Тарифы — Индустрия ИИ',
    description: 'Базовый, Бизнес и VIP-тарифы участия в форуме «Индустрия ИИ».'
  },
  '/registration': {
    title: 'Регистрация — Индустрия ИИ',
    description: 'Регистрация на форум «Индустрия ИИ» — заполните персональные данные и подтвердите email.'
  },
  '/account': {
    title: 'Личный кабинет — Индустрия ИИ',
    description: 'Личный кабинет участника форума «Индустрия ИИ».'
  },
  '/offer': {
    title: 'Публичная оферта — Индустрия ИИ',
    description: 'Публичная оферта об оказании информационно-консультационных услуг в рамках форума «Индустрия ИИ».'
  },
  '/agreement': {
    title: 'Пользовательское соглашение — Индустрия ИИ',
    description: 'Пользовательское соглашение сайта forum-industry.ru.'
  },
  '/privacy': {
    title: 'Политика конфиденциальности — Индустрия ИИ',
    description: 'Политика обработки персональных данных пользователей сайта forum-industry.ru.'
  },
  '/conduct': {
    title: 'Нормы поведения — Индустрия ИИ',
    description: 'Правила поведения участников форума «Индустрия ИИ».'
  }
};

export const topicMeta = {
  'ai-cases': 'Кейсы внедрения ИИ (отраслевые практики)',
  'sales-conversion': 'Как ИИ увеличивает средний чек и снижает возвраты',
  'ai-assistants': 'От промптов к командам ИИ-агентов',
  'ai-labor-market': 'ИИ и рынок труда',
  'ml-video-analytics': 'Улучшаем качество обслуживания в ритейле с помощью ML видеоаналитики',
  'ai-transformation': 'ИИ-трансформация. Почему это не про технологии, а про людей',
  'ai-investments': 'Искусственный интеллект на службе инвестиционных фондов',
  'ai-enterprise': 'От экспериментов к системе: как крупный бизнес внедряет искусственный интеллект',
  'ai-sales-training': 'ИИ НЕ ЗАМЕНИТ МЕНЕДЖЕРОВ, но заменит слабое обучение'
};

export function metaForPath(path) {
  if (path.startsWith('/topic-')) {
    const slug = path.slice('/topic-'.length);
    const subtitle = topicMeta[slug];
    if (subtitle) {
      return {
        title: `${subtitle} — Индустрия ИИ`,
        description: `Тема форума «Индустрия ИИ»: ${subtitle}.`
      };
    }
  }
  return seoMeta[path] ?? seoMeta['/'];
}

export function canonicalForPath(path) {
  return SITE + (path === '/' ? '/' : path);
}
